var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.4939C8.6193 12.4939 7.5 13.6132 7.5 14.9939V19.9939H12.5V14.9939C12.5 13.6132 11.3807 12.4939 10 12.4939Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 14.9939V19.9939H17.5C18.8807 19.9939 20 18.8746 20 17.4939V9.89307C20.0002 9.46014 19.832 9.04413 19.5308 8.73307L12.4492 1.07721C11.1996 -0.274738 9.09074 -0.357746 7.73879 0.891785C7.67457 0.95116 7.6127 1.013 7.55336 1.07721L0.48418 8.73057C0.173945 9.04292 -0.000117128 9.46534 5.9134e-08 9.90557V17.4939C5.9134e-08 18.8746 1.1193 19.9939 2.5 19.9939H5.83332V14.9939C5.84891 12.7215 7.68355 10.8659 9.89867 10.8125C12.1879 10.7573 14.1492 12.6445 14.1667 14.9939Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.4939C8.6193 12.4939 7.5 13.6132 7.5 14.9939V19.9939H12.5V14.9939C12.5 13.6132 11.3807 12.4939 10 12.4939Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.84676fbd181d679920717e5b726e9ce0.svg";
export { ForwardRef as ReactComponent };